import { useSelector } from "react-redux";
import { selectSafeLocale } from "../model/locale";
import React from "react";
import { DatesProvider } from "@noones/ui";
import { StatusIntlProvider } from "@lang/StatusIntlProvider";

const getLocaleInCLDRForm = (locale: string) => locale?.slice(0, 2);

export const IntlProviderWrapper = ({ children }: { children: React.ReactNode }) => {
    const locale = useSelector(selectSafeLocale);

    return (
        <DatesProvider locale="en">
            <StatusIntlProvider key={locale} locale={getLocaleInCLDRForm(locale)}>
                {children}
            </StatusIntlProvider>
        </DatesProvider>
    );
};
